<template>
  <div>
    <SearchInput
      :model-value="keyword"
      placeholder="Search people..."
      class="q-mb-sm"
      @update:model-value="keyword = $event"
    />

    <PersonPicker
      ref="picker"
      :client-id="clientId"
      mode="single"
      :model-value="modelValue !== null ? [modelValue] : []"
      :keyword="keyword"
      @update:model-value="$emit('update:modelValue', $event[0] || null)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import * as dialog from '@/components/modal/dialog';
import notify from '@/components/notify';
import SearchInput from '@/components/SearchInput.vue';
import PersonPicker from './PersonPicker.vue';
import { create } from './person';

interface Data {
  keyword: string;
}

export default defineComponent({
  emits: ['created', 'update:modelValue'],
  components: {
    SearchInput,
    PersonPicker,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Number,
      default: null,
    },
  },
  data(): Data {
    return {
      keyword: '',
    };
  },
  methods: {
    toggleCreate() {
      dialog.prompt({
        parent: this,
        title: 'New Person',
        label: 'Person Name',
      }).onOk((label: string) => this.createPerson(label));
    },
    async createPerson(label: string) {
      try {
        const person = await create(this.clientId, { label });
        (this.$refs.picker as any).addPerson(person);
        this.$emit('update:modelValue', person.id);
        this.$emit('created', person.id);
        notify('Person created.');
      } catch (e) {
        notify('Failed to create person.', 'negative');
      }
    },
  },
});
</script>
